// Blog articles data with multilingual support
export const blogArticles = {
  fr: [],
  en: [],
  nl: []
};

// Helper function to get articles for current language
export const getBlogArticles = (language = 'fr') => {
  return blogArticles[language] || blogArticles.fr;
};
